import IcViewColumn from './IcViewColumn'

export default IcViewColumn
